import { Tooltip } from "src/components/MuiGenerals";
import DialogProvider from "src/features/DialogProvider";
import MultisigCellContent from "./components/MultisigCellContent";
import { IoperationTab } from "../../types/IoperationTab";

function MultisigCell({
  rowData,
  currentTab,
}: {
  rowData: any;
  currentTab: IoperationTab;
}) {
  const isMultisig = !!rowData.rawData.is_multisign;

  if (isMultisig) {
    return (
      <DialogProvider>
        <MultisigCellContent rowData={rowData} currentTab={currentTab} />
      </DialogProvider>
    );
  }

  return (
    <Tooltip title={rowData.multisig}>
      <div>{rowData.multisig}</div>
    </Tooltip>
  );
}

export default MultisigCell;
